/* Johnson product page: compare grid. "Change model" menus swap a column in place and
   recalculate the "Best" markers for the models on screen. Data: script[data-jf-cmp-data]. */
(function () {
  function q(root, k) { return root.querySelector('[data-k="' + k + '"]'); }

  function init(box) {
    if (box.getAttribute('data-jf-ready')) return;
    var el = box.querySelector('script[data-jf-cmp-data]');
    if (!el) return;
    var list;
    try { list = JSON.parse(el.textContent); } catch (e) { return; }
    box.setAttribute('data-jf-ready', '1');
    var byH = {};
    list.forEach(function (p) { byH[p.handle] = p; });
    var current = box.getAttribute('data-current');
    var cols = Array.prototype.slice.call(box.querySelectorAll('thead th[data-jf-col]'));
    var rows = Array.prototype.slice.call(box.querySelectorAll('tbody tr[data-row]'));
    var live = box.querySelector('[data-jf-cmp-live]');

    function shown() { return cols.map(function (th) { return th.getAttribute('data-handle'); }); }

    function fillMenus() {
      var s = shown();
      cols.forEach(function (th) {
        var sel = th.querySelector('select[data-jf-cmp-pick]');
        if (!sel) return;
        var mine = th.getAttribute('data-handle');
        sel.innerHTML = '';
        list.forEach(function (p) {
          if (p.handle === current) return;
          var o = document.createElement('option');
          o.value = p.handle;
          o.textContent = p.title;
          if (p.handle === mine) o.selected = true;
          else if (s.indexOf(p.handle) > -1) o.disabled = true;
          sel.appendChild(o);
        });
        sel.closest('.jf-compare__pick').hidden = sel.options.length < 2;
      });
    }

    function setCol(i, p) {
      var th = cols[i];
      th.setAttribute('data-handle', p.handle);
      var name = q(th, 'name'); name.textContent = p.title; name.href = p.url;
      var img = q(th, 'img'); img.href = p.url; img.innerHTML = '';
      if (p.img) { var im = document.createElement('img'); im.src = p.img; im.alt = ''; img.appendChild(im); }
      q(th, 'price').textContent = p.price;
      var save = q(th, 'save'); save.textContent = p.save; save.hidden = !p.save;
      var diff = q(th, 'diff'); if (diff) diff.textContent = p.diff;
      var bw = q(th, 'bestwrap'); q(th, 'best').textContent = p.best; bw.hidden = !p.best;
      var brow = box.querySelector('.jf-compare__bestrow td[data-jf-col="' + i + '"]');
      if (brow) { var bc = q(brow, 'bestcell'); if (p.best) { bc.textContent = p.best; } else { bc.innerHTML = '<span class="jf-compare__na">–</span>'; } }
      rows.forEach(function (tr) {
        var td = tr.querySelector('td[data-jf-col="' + i + '"]');
        var c = p.cells[+tr.getAttribute('data-row')] || { v: '', n: 0 };
        var v = q(td, 'v');
        if (c.v) { v.textContent = c.v; } else { v.innerHTML = '<span class="jf-compare__na">–</span>'; }
        var vf = q(td, 'vf');
        if (vf) { if (c.f) { vf.textContent = c.f; } else { vf.innerHTML = '<span class="jf-compare__na">–</span>'; } }
      });
      var cta = box.querySelector('.jf-compare__cta td[data-jf-col="' + i + '"]');
      if (cta) { var a = q(cta, 'view'); if (a) a.href = p.url; var vn = q(cta, 'viewname'); if (vn) vn.textContent = ' ' + p.title; }
    }

    function marks() {
      var hs = shown();
      rows.forEach(function (tr) {
        var dir = tr.getAttribute('data-dir');
        var r = +tr.getAttribute('data-row');
        var nums = hs.map(function (h) { var p = byH[h]; return p && p.cells[r] ? +p.cells[r].n || 0 : 0; });
        var vals = nums.filter(function (n) { return n > 0; });
        var best = 0;
        if (dir && vals.length > 1) {
          var distinct = vals.filter(function (n, i) { return vals.indexOf(n) === i; });
          if (distinct.length > 1) best = dir === 'low' ? Math.min.apply(null, vals) : Math.max.apply(null, vals);
        }
        /* a row where every model on screen says the same thing tells the customer nothing: hide it */
        var texts = hs.map(function (h) { var p = byH[h]; return p && p.cells[r] ? String(p.cells[r].v || '').toLowerCase() : ''; });
        var same = texts.length > 1 && texts.every(function (t) { return t === texts[0]; });
        tr.classList.toggle('is-same', same);
        hs.forEach(function (h, i) {
          var td = tr.querySelector('td[data-jf-col="' + i + '"]');
          if (!td) return;
          var on = best > 0 && nums[i] === best;
          td.classList.toggle('is-best', on);
          var m = td.querySelector('.jf-compare__mark'); if (m) m.hidden = !on;
        });
      });
    }

    box.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('select[data-jf-cmp-pick]');
      if (!sel) return;
      var i = cols.indexOf(sel.closest('th'));
      var p = byH[sel.value];
      if (i < 0 || !p) return;
      setCol(i, p);
      marks();
      fillMenus();
      if (live) live.textContent = 'Now comparing with ' + p.title;
    });

    fillMenus();
    marks();
  }

  function all(root) { (root || document).querySelectorAll('[data-jf-compare]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();

/* Compare grid: the ⓘ next to a spec label shows its plain-English explanation */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-jf-explain]');
    if (!btn) return;
    var box = document.getElementById(btn.getAttribute('aria-controls'));
    if (!box) return;
    var open = box.hidden;
    box.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();

/* Specs + warranty on phones: "Show all specs" / "Warranty details" */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-jf-more]');
    if (!btn) return;
    var block = btn.closest('.jf-block');
    if (!block) return;
    var open = !block.classList.contains('is-open');
    block.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!btn.getAttribute('data-more')) btn.setAttribute('data-more', btn.textContent);
    btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
  });
})();